import React from "react";

// Soft park colours - every username gets the same colour every time
const AVATAR_COLORS = [
    "#5c8b4a", "#e2849a", "#5f9db2", "#9a6a41", "#d9a441",
    "#7a9e5e", "#c9637c", "#4f8796", "#b5845a", "#8c7bb8"
];

const hashString = (value) => {
    let hash = 0;
    for (let i = 0; i < value.length; i++) {
        hash = (hash * 31 + value.charCodeAt(i)) | 0;
    }
    return Math.abs(hash);
};

export const avatarColor = (name) => AVATAR_COLORS[hashString(name || "?") % AVATAR_COLORS.length];

const initialsFor = (name) => {
    if (!name) return "?";
    // Temporary usernames look like "rival-giraffe" - use one letter from each word
    const parts = name.split(/[-_\s.]+/).filter(Boolean);
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return name.slice(0, 2).toUpperCase();
};

const Avatar = ({name, size = 36, online, guest, className = "", title}) => {
    return (
        <span
            className={`avatar ${guest ? "avatar--guest" : ""} ${className}`}
            style={{"--size": `${size}px`, background: guest ? undefined : avatarColor(name)}}
            title={title || name}
            aria-hidden="true"
        >
            {initialsFor(name)}
            {online !== undefined && <span className={`avatar__dot ${online ? "online" : ""}`}/>}
        </span>
    );
};

export default Avatar;
